import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { getCategories, getHotArticles, buildCategoryPath } from '@/utils/articles';

export default function CategorySidebar({ currentSlug }: { currentSlug: string }) {
  const categories = getCategories();
  const hotList = getHotArticles(5);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-layout-grid-line text-lg text-primary-500" />
          全部栏目
        </h2>
        <ul className="mt-3 flex flex-col gap-1">
          {categories.map((category) => (
            <li key={category.slug}>
              <Link
                to={buildCategoryPath(category.slug)}
                className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm transition-colors ${
                  category.slug === currentSlug
                    ? 'bg-primary-50 font-medium text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <span className="flex items-center gap-2">
                  <i className={category.icon} />
                  {category.name}
                </span>
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-lg text-accent-600" />
          热门爆料
        </h2>
        <ul className="mt-2 divide-y divide-background-100">
          {hotList.map((item, index) => (
            <li key={item.id}>
              <ArticleCard article={item} variant="rank" rank={index + 1} />
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}